import React from "react";

// Horizontal marquee of "editions" — each card tells a use-case story
// tied back to a specific bundle, so users see a clear path to value.
const CARDS = [
  {
    img: "/assets/Almohada_1_Mejorada.png",
    edition: "Classic Edition",
    tagline: "Where every sleep story starts.",
    cta: "From $147",
    pill: "Bestseller",
    pillCls: "bg-[#d8f06b] text-[#0e0e10]",
    stats: [
      { label: "Sleepers", value: "12K+" },
      { label: "Rating", value: "4.9★" },
      { label: "Trial", value: "100 nt" },
    ],
  },
  {
    img: "/assets/Almohada_2_Mejorada.png",
    edition: "Side Sleeper",
    tagline: "Cervical alignment in 7 nights.",
    cta: "Bundle of 2 · save $211",
    pill: "Couples save 53%",
    pillCls: "bg-[#0e0e10] text-white",
    stats: [
      { label: "Side sleepers", value: "8.4K" },
      { label: "Stiffness", value: "−78%" },
      { label: "Return rate", value: "<2%" },
    ],
  },
  {
    img: "/assets/Almohada_3_Mejorada.png",
    edition: "Cool-Touch",
    tagline: "Sleeps 3°C cooler. All night.",
    cta: "Made for hot sleepers",
    pill: "OEKO-TEX certified",
    pillCls: "bg-[#bfd8ff] text-[#0e0e10]",
    stats: [
      { label: "Hot sleepers", value: "15K" },
      { label: "Rating", value: "5.0★" },
      { label: "Thread ct.", value: "400" },
    ],
  },
  {
    img: "/assets/Almohada_4_Mejorada.png",
    edition: "Travel Edition",
    tagline: "Hotel-grade. At home or 36,000 ft.",
    cta: "Includes carry kit",
    pill: "Frequent flyers",
    pillCls: "bg-[#ffd6e7] text-[#0e0e10]",
    stats: [
      { label: "Travelers", value: "9.2K" },
      { label: "Rating", value: "4.9★" },
      { label: "Carry kit", value: "✓" },
    ],
  },
  {
    img: "/assets/Almohada_5_Mejorada.png",
    edition: "Couples Bundle",
    tagline: "Yours. Theirs. Both perfect.",
    cta: "Bundle of 2 · $187",
    pill: "Save $211",
    pillCls: "bg-[#d8f06b] text-[#0e0e10]",
    stats: [
      { label: "Couples", value: "11K" },
      { label: "Rating", value: "4.9★" },
      { label: "You save", value: "53%" },
    ],
  },
  {
    img: "/assets/Almohada_6_Mejorada.png",
    edition: "Family Pack",
    tagline: "6 pillows. 50% off. Whole family covered.",
    cta: "Bundle of 4 · $297",
    pill: "Best deal · 50% OFF",
    pillCls: "bg-[#0e0e10] text-[#d8f06b]",
    stats: [
      { label: "Families", value: "20K" },
      { label: "Rating", value: "5.0★" },
      { label: "You save", value: "$499" },
    ],
  },
];

export default function PillowGallery() {
  const items = [...CARDS, ...CARDS];

  const scrollToShop = () =>
    document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      data-testid="pillow-gallery-marquee"
      className="aurora-wrap py-10 md:py-14 overflow-hidden"
    >
      <div className="marq-track marq-track-fast">
        {items.map((c, i) => (
          <div
            key={i}
            className="bg-white rounded-3xl border border-black/5 shadow-sm overflow-hidden w-[260px] md:w-[300px] flex-shrink-0 group"
          >
            <div className="aspect-square bg-[#f5f4f1] overflow-hidden relative">
              <img
                src={c.img}
                alt={c.edition}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <span
                className={`absolute top-3 left-3 text-[9px] font-extrabold uppercase tracking-wider px-2.5 py-1 rounded-full ${c.pillCls}`}
              >
                {c.pill}
              </span>
            </div>
            <div className="p-4">
              <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#8a8a8a]">
                {c.edition}
              </div>
              <div className="mt-1 text-[14px] font-extrabold text-[#0e0e10] leading-snug">
                {c.tagline}
              </div>

              <button
                onClick={scrollToShop}
                className="mt-3 w-full text-left text-[12px] font-bold text-[#0e0e10] hover:opacity-70 inline-flex items-center justify-between gap-2"
              >
                <span>{c.cta}</span>
                <span className="text-[#0e0e10]">→</span>
              </button>

              <div className="mt-3 grid grid-cols-3 gap-2 pt-3 border-t border-[#ececec]">
                {c.stats.map((s) => (
                  <Stat key={s.label} label={s.label} value={s.value} />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function Stat({ label, value }) {
  return (
    <div className="text-center">
      <div className="text-[13px] font-extrabold text-[#0e0e10] tabular-nums">
        {value}
      </div>
      <div className="text-[9px] uppercase tracking-wider text-[#8a8a8a] mt-0.5 leading-tight">
        {label}
      </div>
    </div>
  );
}
